/*
 * Branded Best House: "Download picture" on a product page (Brady, 2026-10-06).
 * Saves the photo the visitor is looking at, with their logo on it, to their own device. Free, no email, and the
 * picture is never sent anywhere: it is put together in this browser.
 *
 * It never touches Nick's logo tool. It only READS what his tool has already drawn: the tool lays a
 * <canvas class="bb-logo-overlay"> over the product photo, in the photo's own parent, sized to the whole photo. So
 * the picture is the photo, with that canvas drawn on top at the canvas's own size (never scaled up, which would
 * blur the logo), on a white ground (a see-through photo would otherwise save black), with two lines under it:
 * that it is a preview and not a proof, and the copyright line (Brady, 2026-10-09: so nobody takes our pictures
 * somewhere else). Ported to live 2026-10-26 with that line reworded: the House version said "This mark is the
 * intellectual property of Branded Best" under the BUYER's own logo, which claimed their logo as ours. It now claims
 * only the preview image and says the logo stays theirs. A line under a
 * picture can be cropped off, so the site's address is also written faintly on the photo itself, in a lower corner.
 *
 * It sits right above the logo box's heading (Nick, 2026-10-29). The button shows only once a logo is really painted
 * (the product page makes the canvas before any logo exists).
 * If the picture can't be made (some presets draw from a file the browser won't let a page copy), it says so and
 * nothing else on the page changes.
 */
(function () {
  'use strict';
  if (window.BBHouseSave) return;
  var studio = document.querySelector('bb-logo-studio');
  if (!studio || !/\/products\//.test(location.pathname)) return;

  var handle = (location.pathname.split('/products/')[1] || 'piece').split(/[/?#]/)[0].replace(/[^a-z0-9-]/gi, '') || 'piece';
  var FOOT = 'Preview, not a proof · brandedbest.com';
  // the year the picture is made, so the line never goes stale
  var RIGHTS = '© ' + new Date().getFullYear() + ' Branded Best. All rights reserved. Preview image by Branded Best; your logo stays yours.';
  var MARK = 'brandedbest.com';

  var wrap = document.createElement('div');
  wrap.className = 'bbh-dl';
  wrap.hidden = true;
  wrap.innerHTML = '<button type="button" class="bbh-dl__btn">Download this picture</button>' +
    '<span class="bbh-dl__note" role="status" aria-live="polite"></span>';
  // right above the logo box's heading ("See your logo on it"), under the larger-runs line: close to the picture it saves
  // (Nick, 2026-10-29: "put download this picture above, see your logo on it"; it was under the whole box)
  var top = studio.querySelector('.bb-ls__heading, .bb-ls__desc, [data-drop]');
  if (top) top.insertAdjacentElement('beforebegin', wrap); else studio.insertAdjacentElement('afterend', wrap);
  var btn = wrap.querySelector('button'), note = wrap.querySelector('.bbh-dl__note');

  // the overlay with the most of itself on screen, paired with the photo in its own parent
  function current() {
    var best = null, bestArea = 0;
    [].forEach.call(document.querySelectorAll('canvas.bb-logo-overlay'), function (c) {
      var host = c.parentElement, img = host && host.querySelector('img');
      if (!img || !c.width || !c.height) return;
      var r = c.getBoundingClientRect();
      var w = Math.min(r.right, innerWidth) - Math.max(r.left, 0), h = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
      var area = w > 0 && h > 0 ? w * h : (r.width > 0 && r.height > 0 ? 1 : 0);
      if (area > bestArea) { bestArea = area; best = { canvas: c, img: img }; }
    });
    return best;
  }

  // true when the overlay has any paint on it. A canvas the browser won't let us read counts as painted: the
  // download then explains itself instead of the button never appearing.
  function painted(c) {
    try {
      // shrunk only a little: a small mark (a pen's) would fade to nothing in a tiny copy
      var n = 200, t = document.createElement('canvas');
      t.width = n; t.height = n;
      var x = t.getContext('2d');
      x.drawImage(c, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data;
      for (var i = 3; i < d.length; i += 4) if (d[i] > 2) return true;
      return false;
    } catch (e) { return true; }
  }

  function refresh() {
    var cur = current();
    var on = !!(cur && painted(cur.canvas));
    if (wrap.hidden === on) { wrap.hidden = !on; if (!on) note.textContent = ''; }
  }

  function loadPhoto(img) {
    return new Promise(function (resolve, reject) {
      var src = img.currentSrc || img.src;
      if (!src) { reject(new Error('no photo')); return; }
      var p = new Image();
      p.crossOrigin = 'anonymous';
      p.onload = function () { resolve(p); };
      p.onerror = function () { reject(new Error('photo')); };
      // a different address from the one on the page, so the browser asks the image server again with permission
      p.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'bbh=dl';
    });
  }

  function compose(cur) {
    return loadPhoto(cur.img).then(function (photo) {
      var w = cur.canvas.width, h = cur.canvas.height;
      var foot = Math.max(46, Math.round(h * 0.09));
      var out = document.createElement('canvas');
      out.width = w; out.height = h + foot;
      var x = out.getContext('2d');
      x.fillStyle = '#ffffff';
      x.fillRect(0, 0, w, h + foot);
      x.drawImage(photo, 0, 0, w, h);
      x.drawImage(cur.canvas, 0, 0, w, h);
      // the faint mark, on the photo itself: dark on a light photo, white on a dark one, read from the corner it sits in
      var mk = Math.max(11, Math.round(w * 0.022)), pad = Math.round(mk * 0.9);
      x.save();
      x.font = '600 ' + mk + 'px Archivo, Helvetica, Arial, sans-serif';
      x.textAlign = 'right';
      x.textBaseline = 'alphabetic';
      var light = true;
      try {
        var mw = Math.min(w, Math.ceil(x.measureText(MARK).width)) || 1;
        var px = x.getImageData(Math.max(0, w - pad - mw), Math.max(0, h - pad - mk), mw, mk).data, sum = 0;
        for (var i = 0; i < px.length; i += 4) sum += px[i] * 0.299 + px[i + 1] * 0.587 + px[i + 2] * 0.114;
        light = sum / (px.length / 4) > 140;
      } catch (e) { /* a photo the browser won't let us read: keep the dark mark */ }
      x.fillStyle = light ? 'rgba(12, 12, 12, 0.3)' : 'rgba(255, 255, 255, 0.5)';
      x.fillText(MARK, w - pad, h - pad);
      x.restore();
      x.fillStyle = '#0c0c0c';
      x.fillRect(0, h, w, foot);
      x.fillStyle = '#ffffff';
      x.textAlign = 'center';
      x.textBaseline = 'middle';
      x.font = '500 ' + Math.round(foot * 0.27) + 'px Archivo, Helvetica, Arial, sans-serif';
      x.fillText(FOOT, w / 2, h + foot * 0.32, w - 16);
      x.font = '400 ' + Math.round(foot * 0.2) + 'px Archivo, Helvetica, Arial, sans-serif';
      x.fillText(RIGHTS, w / 2, h + foot * 0.7, w - 16);
      return new Promise(function (resolve, reject) {
        try { out.toBlob(function (b) { b ? resolve(b) : reject(new Error('blob')); }, 'image/jpeg', 0.92); }
        catch (e) { reject(e); }
      });
    });
  }

  function hand(blob) {
    var name = 'branded-best-' + handle + '.jpg';
    var touch = window.matchMedia && matchMedia('(pointer: coarse)').matches;
    try {
      var file = new File([blob], name, { type: 'image/jpeg' });
      if (touch && navigator.canShare && navigator.canShare({ files: [file] })) {
        // on a phone the share sheet is where "Save Image", Messages and Mail are
        return navigator.share({ files: [file] }).then(function () { return 'shared'; }, function (e) {
          if (e && e.name === 'AbortError') return 'closed';
          throw e;
        });
      }
    } catch (e) { /* fall through to a plain download */ }
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = name; a.rel = 'noopener';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 30000);
    return Promise.resolve('saved');
  }

  btn.addEventListener('click', function () {
    var cur = current();
    if (!cur) return;
    btn.disabled = true;
    note.textContent = '';
    compose(cur).then(hand).then(function (how) {
      note.textContent = how === 'saved' ? 'Saved to your downloads. It is a preview: your proof comes before anything is made.' :
        how === 'shared' ? 'Done. It is a preview: your proof comes before anything is made.' : '';
    }).catch(function () {
      note.textContent = 'This picture can’t be saved from here. A screenshot works the same.';
    }).then(function () { btn.disabled = false; });
  });

  window.addEventListener('bb-logo:saved', function () { setTimeout(refresh, 600); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  setInterval(function () { if (!document.hidden) refresh(); }, 1500);
  refresh();

  window.BBHouseSave = { refresh: refresh, compose: function () { var c = current(); return c ? compose(c) : Promise.reject(new Error('none')); } };
})();
